import e from "./isBrowser.js";
export default (function () {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e() && window.location.href;
  return (i.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(function (e, i) {
    return e[i.slice(0, i.indexOf("="))] = i.slice(i.indexOf("=") + 1), e;
  }, {});
});